import * as Sentry from "@sentry/nextjs";
import type { SnakeCase } from "type-fest";
import type { ZodObject, z } from "zod";

export const createEventFactory =
  <Event extends string, Schema extends ZodObject>(event: SnakeCase<Event>, schema: Schema) =>
  (data: z.infer<Schema>) => {
    const validation = schema.safeParse(data);

    if (validation.success) {
      return { ...validation.data, event } as Record<string, unknown>;
    }

    Sentry.captureException(`[gtm/${event}] Unexpected error: ${validation.error.message}`);
    return null;
  };

export const pushGtmEvent = (event: Nullable<Record<string, unknown>>) => {
  const { dataLayer } = window;

  if (!event) {
    return;
  }

  if (!dataLayer) {
    Sentry.captureException("dataLayer don't exists");
    return;
  }

  dataLayer.push(event);
};
